import { useMemo } from 'react';
import classNames from 'classnames';
import { DOWNLOAD_ONLY, useHubSwitch } from '@bpm-web-app/utils';
import { Library, useLibraryTabs } from 'libs/utils/src/lib/library-tabs.context';
import ChevronRight from '../../assets/icons/chevron-right.svg';
import mainHeaderStyles from './supreme-header.module.css';
import { useSession } from '../shared/session-provider/session-provider';
import { AppLink } from '../shared/app-link/app-link';

interface ProfileNavItemsProps {
    hideAddMusic?: boolean;
}

export const ProfileNavItems = ({ hideAddMusic = false }: ProfileNavItemsProps) => {
    const { logout } = useSession();
    const { library } = useLibraryTabs();
    const { isArtistPlatform, isCreate } = useHubSwitch();

    const chevronRightIcon = useMemo(() => <ChevronRight />, []);
    return (
        <nav>
            <ul className={mainHeaderStyles['supreme-header__user-menu-list']}>
                <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                    <AppLink href="/account/overview">
                        <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                            <span>Account</span>
                            {chevronRightIcon}
                        </a>
                    </AppLink>
                </li>
                {!isArtistPlatform &&
                    <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                        <AppLink href="/account/plan">
                            <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                                <span>Plans</span>
                                {chevronRightIcon}
                            </a>
                        </AppLink>
                    </li>
                }
                {!isArtistPlatform &&
                    <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                        <AppLink href="/account/payment">
                            <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                                <span>Payment</span>
                                {chevronRightIcon}
                            </a>
                        </AppLink>
                    </li>
                }
                {!hideAddMusic && !DOWNLOAD_ONLY && !isArtistPlatform && (
                    <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                        <AppLink href="/account/add-music">
                            <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                                <span>Add Music</span>
                                {chevronRightIcon}
                            </a>
                        </AppLink>
                    </li>
                )}
                {!isArtistPlatform &&
                    <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                        <AppLink href="/account/downloads">
                            <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                                <span>Downloads</span>
                                {chevronRightIcon}
                            </a>
                        </AppLink>
                    </li>
                }
                <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                    <AppLink href="/account/settings">
                        <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                            <span>Settings</span>
                            {chevronRightIcon}
                        </a>
                    </AppLink>
                </li>
                <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                    <AppLink href="/account/support">
                        <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                            <span>Support </span>
                            {chevronRightIcon}
                        </a>
                    </AppLink>
                </li>
                {!isArtistPlatform && (
                    <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                        <AppLink href={isCreate ? 'https://classic.create.bpmsupreme.com' : library === Library.Main ? 'https://classic.bpmsupreme.com' : 'https://classic.latino.bpmsupreme.com'}>
                            <a className={mainHeaderStyles['supreme-header__user-menu-item']}>
                                <span>Switch to Classic Mode </span>
                                {chevronRightIcon}
                            </a>
                        </AppLink>
                    </li>
                )}
                <li className={mainHeaderStyles['supreme-header__user-menu-list-item']}>
                    <button
                        type="button"
                        aria-label="logout"
                        className={classNames(mainHeaderStyles['supreme-header__user-menu-item'], mainHeaderStyles['supreme-header__user-menu-item--logout'])}
                        onClick={logout}
                    >
                        Logout
                    </button>
                </li>
            </ul>
        </nav>
    );
};
